import React, { Component } from "react";
import BarTitle from "../../components/BarTitle/index";

import Painel from "../../components/Painel/index";
import constants from "../../constants";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatReal } from "../Util/util";
import IntlCurrencyInput from "react-intl-currency-input";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  DirectionsRenderer,
} from "react-google-maps";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { calculatePriceDistance } from "../../services/agent";
import swal from "sweetalert";
import PainelLittle from "../../components/Painel/painellittle";

const removeDots = (str) => str.replace(/\./g, "");

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const MapWithAMarker = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      zoom={parseInt(props.zoom)}
      defaultCenter={{ lat: -34.397, lng: 150.644 }}
    >
      <DirectionsRenderer directions={props.directions} />
    </GoogleMap>
  ))
);
class MakeSolicitation extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFlagChange = this.onFlagChange.bind(this);
    this.onAmountChange = this.onAmountChange.bind(this);
    this.updateDirections = this.updateDirections.bind(this);

    this.state = {
      price: 0,
      purchase_id: 0,
      test: 0,
      directions: null,
      addShipping: false,
      addShippingEntrega: false,
      addShippingDelivery: false,
      directionsInitial: null,
      directionsFinal: null,
      directionsInfo: null,
      priceDistanceEntrega: null,
      priceDistanceDelivery: null,
      initialAddress: null,
      finalAddress: null,
      returnTaxEntrega: {},
      returnTaxDelivery: {},
    };

    const el = document.createElement("div");
    el.innerHTML = `<a target="_blank" class="btn btn-primary" >Clique aqui para baixar o relatório em formato PDF.</a>`;
  }

  handleChange = (initialAddress) => {
    this.setState({ initialAddress });
  };

  handleSelect = async (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.setState({
          initialAddress: address,
          directionsInitial: latLng,
        });
        this.updateDirections();
      })
      .catch((error) => console.error("Error", error));
  };

  handleChange2 = (finalAddress) => {
    this.setState({ finalAddress });
  };

  calculateReturnTax() {
    let priceDistanceDelivery = this.state.priceDistanceDelivery;
    let priceDistanceEntrega = this.state.priceDistanceEntrega;

    let urlCalculateReturnTaxEntrega =
      constants().URL_SERVICE +
      `setting/distancerate/calculate_return_tax/?value=${priceDistanceEntrega.price}&service_type=1`;

    axios.get(urlCalculateReturnTaxEntrega).then((response) => {
      this.setState({
        returnTaxEntrega: response.data,
      });
    });

    let urlCalculateReturnTaxDelivery =
      constants().URL_SERVICE +
      `setting/distancerate/calculate_return_tax/?value=${priceDistanceDelivery.price}&service_type=2`;

    axios.get(urlCalculateReturnTaxDelivery).then((response) => {
      this.setState({
        returnTaxDelivery: response.data,
      });
    });
  }

  handleSelect2 = async (address2) => {
    geocodeByAddress(address2)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.setState({
          finalAddress: address2,
          directionsFinal: latLng,
        });
        this.updateDirections();
      })
      .catch((error) => console.error("Error", error));
  };
  onFlagChange(event) {
    this.setState({
      flag: event.currentTarget.value,
    });
  }

  onAmountChange(event) {
    let val = removeDots(event.target.value);
    event.target.value = val.replace(/\d{2}$/, (e) => "." + e);
  }

  handleSubmit(event) {
    event.preventDefault();
    const description = this.refs.description.value;

    const makeATransactionUrl =
      constants().URL_SERVICE +
      "establishment/paymentrequest/create_payment_request/";
    let price = null;

    if (this.state.addShipping) {
      if (this.state.addShippingDelivery) {
      }
    }

    let shipping;

    if (this.state.addShipping) {
      if (this.state.addShippingEntrega) {
        shipping = this.state.priceDistanceEntrega;
      }

      if (this.state.addShippingDelivery) {
        shipping = this.state.priceDistanceDelivery;
      }
    }

    let returnTax = null;

    if (this.state.addReturnTax) {
      if (this.state.addShippingDelivery) {
        returnTax = parseFloat(this.state.returnTaxDelivery.tax_price);
      }

      if (this.state.addShippingEntrega) {
        returnTax = parseFloat(this.state.returnTaxEntrega.tax_price);
      }
    }

    axios
      .post(
        makeATransactionUrl,
        {
          price: this.state.price,
          client_cpf: this.props.location.state.cpf,
          payment_type: 1,
          purchase_id: this.state.purchase_id,
          description: description,
          shipping: this.state.addShipping ? parseFloat(shipping.price) : null,
          initialAddress: this.state.addShipping
            ? this.state.initialAddress
            : null,
          finalAddress: this.state.addShipping ? this.state.finalAddress : null,
          returnTax: returnTax,
        },
        { headers: { Authorization: "Token " + localStorage.token } }
      )
      .then((response) => {
        toast.success("Solicitação efetuada com sucesso!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        if (this.state.addShipping) {
          swal("Solicitação criada com sucesso!", {
            buttons: {
              cupom: {
                text: "Imprimir cupom",
                value: "cupom",
              },
              catch: {
                text: "Ir para tela de solicitações",
                value: "catch",
              },
              cancel: "Fechar",
            },
          }).then((value) => {
            switch (value) {
              case "cupom":
                const win = window.open(
                  `/#/render-cupom/${response.data.id}`,
                  "_blank"
                );
                win.focus();
                this.props.router.push("/home/solicitations/");
                break;

              case "catch":
                this.props.router.push("/home/solicitations/");
                break;
            }
          });
        } else {
          this.props.router.push("/home/solicitations/");
        }
      })
      .catch((error) => console.error(error));
  }

  updateDirections() {
    if (this.state.directionsInitial && this.state.directionsFinal) {
      let initial = this.state.directionsInitial;
      let final = this.state.directionsFinal;

      const directionsService = new window.google.maps.DirectionsService();

      const origin = { lat: initial.lat, lng: initial.lng };
      const destination = { lat: final.lat, lng: final.lng };

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        async (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            let directionsInfo = result.routes[0].legs[0];

            if (this.state.price && this.state.addShippingEntrega) {
              this.setState({
                price:
                  this.state.price -
                  parseFloat(this.state.priceDistanceEntrega.price),
                addShippingEntrega: false,
              });
            }

            if (this.state.price && this.state.addShippingDelivery) {
              this.setState({
                price:
                  this.state.price -
                  parseFloat(this.state.priceDistanceDelivery.price),
                addShippingDelivery: false,
              });
            }

            //Entrega
            let priceDistanceEntrega = await calculatePriceDistance(
              directionsInfo.distance.text.replace(" km", ""),
              1
            );

            this.setState({
              priceDistanceEntrega: priceDistanceEntrega,
            });

            //Delivery
            let priceDistanceDelivery = await calculatePriceDistance(
              directionsInfo.distance.text.replace(" km", ""),
              2
            );
            this.setState({
              priceDistanceDelivery: priceDistanceDelivery,
            });

            this.setState({
              directions: result,
              directionsInfo,
            });
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  }

  getTotalFinal() {
    let total;
    total = this.state.price;

    if (
      this.state.addShipping &&
      (this.state.addShippingEntrega || this.state.addShippingDelivery)
    ) {
      if (this.state.addShippingEntrega) {
        total = total + parseFloat(this.state.priceDistanceEntrega.price);
      } else if (this.state.addShippingDelivery) {
        total = total + parseFloat(this.state.priceDistanceDelivery.price);
      }
    }

    if (this.state.addReturnTax) {
      if (this.state.addShippingDelivery) {
        total = total + parseFloat(this.state.returnTaxDelivery.tax_price);
      }

      if (this.state.addShippingEntrega) {
        total = total + parseFloat(this.state.returnTaxEntrega.tax_price);
      }
    }

    let totalFormatedBRL = total.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    return totalFormatedBRL;
  }

  render() {
    const handleChange = (event, value, maskedValue) => {
      event.preventDefault();

      this.setState({
        price: value,
      });
    };

    let resultCielo = "";

    if (this.state.httpStatus !== 0 && this.state.httpStatus === 400) {
      resultCielo = (
        <div>
          <h4>Resultado transação:</h4>
          <span className="label label-danger h2">Erro na transação</span>
          <h5>Código do erro: {this.state.code}</h5>
          <h5>Mensagem Cielo: {this.state.message} </h5>
        </div>
      );
    }

    if (this.state.httpStatus !== 0 && this.state.httpStatus === 200) {
      resultCielo = (
        <div>
          <h4>Resultado transação:</h4>
          <span className="label label-success h2">
            Operacao realizada com sucesso
          </span>
          <h5>Mensagem Cielo: {this.state.message} </h5>
          <h5>Tid: {this.state.body.Payment.Tid} </h5>
          <h5>Comprovante de Venda: {this.state.body.Payment.ProofOfSale} </h5>
          <h5>
            Código de autorização: {this.state.body.Payment.AuthorizationCode}{" "}
          </h5>
          <h5>Id do pagamento: {this.state.body.Payment.PaymentId} </h5>
          <h5>Código do Cielo: {this.state.code}</h5>
        </div>
      );
    }

    return (
      <div>
        <BarTitle name="Criar solicitação de pagamento" />
        <div className="wrapper-md">
          <form onSubmit={this.handleSubmit}>
            <Painel title="Dados do cliente">
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Telefone</th>
                    <th>CPF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td> {this.props.location.state.id} </td>
                    <td>
                      {this.props.location.state.first_name}{" "}
                      {this.props.location.state.last_name}
                    </td>
                    <td>{this.props.location.state.email}</td>
                    <td>{this.props.location.state.phone}</td>
                    <td>{this.props.location.state.cpf}</td>
                  </tr>
                </tbody>
              </table>
            </Painel>
            <PainelLittle title="Dados da solicitação">
              <fieldset>
                <div className="row">
                  <div className="col-md-6">
                    <div className="control-group">
                      <div className="controls">
                        <div className="row">
                          <div className="col-md-4">
                            <label label-default="" className="control-label">
                              Valor
                            </label>
                            <IntlCurrencyInput
                              currency="BRL"
                              config={currencyConfig}
                              className="form-control"
                              onChange={handleChange}
                              value={this.state.price}
                            />
                          </div>
                          {/* <div className="col-md-4">
                            <label label-default="" className="control-label">
                              Id do Pedido
                            </label>
                            <input
                              type="number"
                              name="numberOfGuests"
                              className="form-control"
                              // pattern='[0-9]{0,5}'
                              onChange={(value) => {
                                this.setState({
                                  purchase_id: value.target.value,
                                });
                              }}
                              value={this.state.purchase_id}
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>

                    {/* <div className="control-group">
                      <div className="controls">
                        <div className="row">
                          <div className="col-md-6">
                            <label label-default="" className="control-label">
                              Id do Pedido
                            </label>
                            <input
                                type='number'
                                name="numberOfGuests"
                                className='form-control'
                                // pattern='[0-9]{0,5}'
                                onChange={value => {
                                  this.setState({ purchase_id: value.target.value });
                                }}
                                value={this.state.purchase_id}
                            />
                           
                          </div>
                          
                        </div>
                      </div>
                    </div> */}

                    <div className="control-group">
                      <div className="controls">
                        <div className="row">
                          <div className="col-md-12">
                            <label label-default="" className="control-label">
                              Descrição
                            </label>
                            <textarea
                              type="text"
                              className="form-control"
                              autocomplete="off"
                              title="First four digits"
                              required
                              rows="1"
                              ref="description"
                            />
                            <br />
                            <div class="checkbox-section">
                              <input
                                type="checkbox"
                                onChange={() => {
                                  this.setState({
                                    addShipping: !this.state.addShipping,
                                  });

                                  setTimeout(() => {
                                    this.setState({
                                      initialAddress:
                                        localStorage.getItem("address"),
                                      directionsInitial: {
                                        lat: parseFloat(
                                          localStorage.getItem("latitude")
                                        ),
                                        lng: parseFloat(
                                          localStorage.getItem("longitude")
                                        ),
                                      },
                                    });

                                    this.updateDirections();
                                  }, 300);
                                }}
                                checked={this.state.addShipping}
                              />

                              <label style={{ "margin-left": "5px" }} for="">
                                Adicionar Frete (O valor será somado ao valor
                                final).
                              </label>
                              <br />
                              <div
                                style={{
                                  display: !this.state.addShipping && "none",
                                }}
                              >
                                <div className="control-group">
                                  <div className="controls ">
                                    <div className="control-group">
                                      <PlacesAutocomplete
                                        value={this.state.initialAddress}
                                        onChange={this.handleChange}
                                        onSelect={this.handleSelect}
                                      >
                                        {({
                                          getInputProps,
                                          suggestions,
                                          getSuggestionItemProps,
                                          loading,
                                        }) => (
                                          <div>
                                            <input
                                              {...getInputProps({
                                                placeholder: "Local Partida",
                                                className:
                                                  "location-search-input",
                                              })}
                                              className="form-control"
                                            />
                                            <div className="autocomplete-dropdown-container">
                                              {loading && <div>Loading...</div>}
                                              {suggestions.map((suggestion) => {
                                                const className =
                                                  suggestion.active
                                                    ? "suggestion-item--active"
                                                    : "suggestion-item";
                                                // inline style for demonstration purpose
                                                const style = suggestion.active
                                                  ? {
                                                      backgroundColor:
                                                        "#fafafa",
                                                      cursor: "pointer",
                                                    }
                                                  : {
                                                      backgroundColor:
                                                        "#ffffff",
                                                      cursor: "pointer",
                                                    };
                                                return (
                                                  <div
                                                    {...getSuggestionItemProps(
                                                      suggestion,
                                                      {
                                                        className,
                                                        style,
                                                      }
                                                    )}
                                                  >
                                                    <span>
                                                      {suggestion.description}
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </PlacesAutocomplete>
                                    </div>
                                  </div>
                                </div>
                                  <div className="control-group">
                                  <div className="controls ">
                                    <div className="control-group">
                                      <PlacesAutocomplete
                                        value={this.state.finalAddress}
                                        onChange={this.handleChange2}
                                        onSelect={this.handleSelect2}
                                      >
                                        {({
                                          getInputProps,
                                          suggestions,
                                          getSuggestionItemProps,
                                          loading,
                                        }) => (
                                          <div>
                                            <input
                                              {...getInputProps({
                                                placeholder: "Local Final",
                                                className:
                                                  "location-search-input",
                                              })}
                                              className="form-control"
                                            />
                                            <div className="autocomplete-dropdown-container">
                                              {loading && <div>Loading...</div>}
                                              {suggestions.map((suggestion) => {
                                                const className =
                                                  suggestion.active
                                                    ? "suggestion-item--active"
                                                    : "suggestion-item";
                                                // inline style for demonstration purpose
                                                const style = suggestion.active
                                                  ? {
                                                      backgroundColor:
                                                        "#fafafa",
                                                      cursor: "pointer",
                                                    }
                                                  : {
                                                      backgroundColor:
                                                        "#ffffff",
                                                      cursor: "pointer",
                                                    };
                                                return (
                                                  <div
                                                    {...getSuggestionItemProps(
                                                      suggestion,
                                                      {
                                                        className,
                                                        style,
                                                      }
                                                    )}
                                                  >
                                                    <span>
                                                      {suggestion.description}
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </PlacesAutocomplete>

                                                                       {this.state.directionsInfo && (
                                      <div class="row">
                                        <div class="col-md-6">
                                          <br />
                                          <label
                                            for=""
                                            style={{
                                              "font-weight": "bold",
                                            }}
                                          >
                                            Escolha abaixo o tipo de frete.
                                          </label>
                                          <br />
                                          <input
                                            type="checkbox"
                                            onChange={() => {
                                              this.setState({
                                                addShippingEntrega:
                                                  !this.state
                                                    .addShippingEntrega,
                                                addShippingDelivery: false,
                                              });
                                              this.calculateReturnTax();
                                            }}
                                            checked={
                                              this.state.addShippingEntrega
                                            }
                                          />
                                          <label
                                            style={{
                                              "margin-left": "5px",
                                              "font-size": 16,
                                            }}
                                            for=""
                                          >
                                            Entrega:{" "}
                                            {
                                              this.state.priceDistanceEntrega
                                                .price_monetary
                                            }
                                          </label>
                                          <br />
                                          <input
                                            type="checkbox"
                                            onChange={() => {
                                              this.setState({
                                                addShippingDelivery:
                                                  !this.state
                                                    .addShippingDelivery,
                                                addShippingEntrega: false,
                                              });
                                              this.calculateReturnTax();
                                            }}
                                            checked={
                                              this.state.addShippingDelivery
                                            }
                                          />

                                          <label
                                            style={{
                                              "margin-left": "5px",
                                              "font-size": 16,
                                            }}
                                            for=""
                                          >
                                            Delivery:{" "}
                                            {
                                              this.state.priceDistanceDelivery
                                                .price_monetary
                                            }
                                          </label>
                                          <br/>
                                          <span for="">
                                            Distancia:{" "}
                                            {
                                              this.state.directionsInfo.distance
                                                .text
                                            }
                                            , Tempo:{" "}
                                            {
                                              this.state.directionsInfo.duration
                                                .text
                                            }
                                          </span>
                                          <br />
                                          {(this.state.addShippingDelivery ||
                                            this.state.addShippingEntrega) && (
                                            <div>
                                              <input
                                                type="checkbox"
                                                onChange={() =>
                                                  this.setState({
                                                    addReturnTax:
                                                      !this.state.addReturnTax,
                                                  })
                                                }
                                                checked={
                                                  this.state.addReturnTax
                                                }
                                              />
                                              <label
                                                style={{ "margin-left": "5px" }}
                                                for=""
                                              >
                                                Adicionar retorno (
                                                {this.state
                                                  .addShippingDelivery &&
                                                  this.state.returnTaxDelivery
                                                    .tax_price_monetary}
                                                {this.state
                                                  .addShippingEntrega &&
                                                  this.state.returnTaxEntrega
                                                    .tax_price_monetary}
                                                )
                                              </label>
                                              <br />
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          class="col-md-6"
                                          style={{
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "align-items": "center",
                                            "align-self": "center",
                                            height: "100px",
                                          }}
                                        >
                                          <h3>
                                            Valor total: {this.getTotalFinal()}
                                          </h3>
                                          <div className="controls">
                                            <button
                                              type="submit"
                                              className="btn btn-primary"
                                            >
                                              Enviar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="control-group">
                      <div className="controls">
                        <div className="control-group">
                          <label
                            label-default=""
                            className="control-label"
                          ></label>
                          {!this.state.addShipping && (
                            <div className="controls">
                              <button type="submit" className="btn btn-primary">
                                Enviar
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-md-6"
                    style={{ display: !this.state.addShipping && "none" }}
                  >
                    {resultCielo}
                    <MapWithAMarker
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCHAJKwsNnBiAHVlCPZe59h024ynGRvjOg&v=3.exp&libraries=geometry,drawing,places"
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `400px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                      zoom={0}
                      directions={this.state.directions}
                    />
                  </div>
                </div>
              </fieldset>
            </PainelLittle>
          </form>
        </div>
      </div>
    );
  }
}

export default MakeSolicitation;



// WEBPACK FOOTER //
// ./src/views/PaymentSolicitation/makesolicitation.js